import {
    ADD_ALERTS,
    UPDATE_ALERTS,
    CLOSE_SOCKET,
    OPEN_SOCKET,
    REMOVE_ALERTS, RESET_ALERTS,
    SET_ALERTS, RECHECK_ALERTS
} from "../actions/WEBSOCKET_ACTIONS";


const defaultState = {
    isOpened: false,
    alerts: [],
    recheckAlerts: []

}

export const webSocketReducer = (state = defaultState, action) => {
    switch (action.type) {
        case OPEN_SOCKET:
            return {...state, isOpened: true}
        case CLOSE_SOCKET:
            return {...state, isOpened: false}
        case SET_ALERTS:
            return {...state, alerts: action.payload}
        case ADD_ALERTS:
            return { ...state, alerts: [...state.alerts, ...action.payload] };
        case REMOVE_ALERTS:
            return {
                ...state,
                alerts: state.alerts.filter((alert) => !action.payload.includes(alert.alert_id)),
            };
        case UPDATE_ALERTS:
            const newAlerts = [...state.alerts]
            action.payload.map((alert) => {
                const index = newAlerts.findIndex((item) => item.alert_id === alert.alert_id)
                if (index !== -1) {
                    newAlerts[index] = alert
                } else {
                    newAlerts.push(alert)
                }
            })
            return {...state, alerts: newAlerts}
        case RECHECK_ALERTS:
            let processingAlerts = [...state.recheckAlerts]
            action.payload.forEach((alert) => {
                const index = processingAlerts.findIndex((item) => item.alert_id === alert.alert_id)
                if (alert.recheck_status !== "done"){
                    if (index !== -1) {
                        processingAlerts[index] = alert
                    } else {
                        processingAlerts.push(alert)
                    }
                } else {
                    if (index !== -1) {
                        processingAlerts.splice(index, 1);
                    }
                }
            }
            )
            return {...state, recheckAlerts: processingAlerts}
        case RESET_ALERTS:
            return {...state, alerts: []}
        default:
            return state
    }
}

export const openWebSocket = () => ({
    type: OPEN_SOCKET
})
export const closeWebSocket = () => ({
    type: CLOSE_SOCKET
})
export const setAlerts = (alerts) => ({
    type: SET_ALERTS,
    payload: alerts
})
export const addAlerts = (alerts) => ({
    type: ADD_ALERTS,
    payload: alerts
})
export const removeAlerts = (alerts) => ({
    type: REMOVE_ALERTS,
    payload: alerts
})

export const updateAlerts = (alerts) => ({
    type: UPDATE_ALERTS,
    payload: alerts
})
export const resetAlerts = () => ({
    type: RESET_ALERTS
})

export const recheckAlerts = (alerts) => ({
    type: RECHECK_ALERTS,
    payload: alerts
})
